import * as service from "./service";

export type LegalDocumentType = "business_terms" | "student_terms" | "privacy_policy";

export interface LegalDocument {
  type: LegalDocumentType;
  locale: string;
  version: string;
  title?: string | null;
  content: string;
  effective_at?: string | null;
}

export const getLegalDocumentAPI = async (type: LegalDocumentType, locale: string) => {
  try {
    return await service.call("GET", "api/legal/document", { type, locale }, { timeout: 20000 });
  } catch (err) {
    console.error(`getLegalDocumentAPI ${err}`);
    return { result: null, status: 2 };
  }
};
